import React from "react";
import ImportContactsOutlinedIcon from "@mui/icons-material/ImportContactsOutlined";
import "./TheStudentDashboard.css"; // Make sure the CSS file is imported
import Available from "./imageFiles/Available.png";
import Enrolled from "./imageFiles/Enrolled.png";
import Completed from "./imageFiles/Completed.png";
import { Skeleton } from "@mui/material";

const PaperCounts = ({ availablePaperCount, enrolledPaperCount, completedPaperCount, student_dashboard_initial_loading }) => {
  return (
    <div className="paper-counts-box column">
      <div className="paper-counts-header">
        <h6 className="paper-counts-title">Exam counts</h6>
      </div>

      <div className="paper-counts-row row">
        {student_dashboard_initial_loading ?
          <>
            <div className="row">
              <Skeleton
                sx={{
                  height: '120px',
                  width: '120px',
                  borderRadius: "10px",
                  padding: "1rem"
                }}
                variant="rectangular"
                animation="wave"
              />
            </div>
            <div className="row">
              <Skeleton
                sx={{
                  height: '120px',
                  width: '120px',
                  borderRadius: "10px",
                  padding: "1rem"
                }}
                variant="rectangular"
                animation="wave"
              />
            </div>
            <div className="row">
              <Skeleton
                sx={{
                  height: '120px',
                  width: '120px',
                  borderRadius: "10px",
                  padding: "1rem"
                }}
                variant="rectangular"
                animation="wave"
              />
            </div>
          </>
          :
          <>
            <div className="paper-count-card row">
              <img
                src={Available}
                alt="Available"
                className="paper-icon-img"
              />
              <div className="paper-count-content">
                <ImportContactsOutlinedIcon style={{ color: "#3E3E3E", marginRight: "8px" }} />
                <p className="count-label">Available</p>
                <p className="count-value">{availablePaperCount}</p>
              </div>
            </div>

            <div className="paper-count-card row">
              <img
                src={Enrolled}
                alt="Enrolled"
                className="paper-icon-img"
              />
              <div>
                <ImportContactsOutlinedIcon style={{ color: "#3E3E3E", marginRight: "8px" }} />
                <p className="count-label">Enrolled</p>
                <p className="count-value">{enrolledPaperCount}</p>
              </div>
            </div>

            <div className="paper-count-card row">
              <img
                src={Completed}
                alt="Completed"
                className="paper-icon-img"
              />
              <div>
                <ImportContactsOutlinedIcon style={{ color: "#3E3E3E", marginRight: "8px" }} />
                <p className="count-label">Completed</p>
                <p className="count-value">{completedPaperCount}</p>
              </div>
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default PaperCounts;
